var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 7.667a5.667 5.667 0 0 1-7.704 5.29 2 2 0 0 0-.22-.078.6.6 0 0 0-.124-.017c-.047-.001-.098.004-.202.015l-3.414.353c-.325.033-.488.05-.584-.008a.33.33 0 0 1-.156-.233c-.017-.112.06-.256.216-.543l1.09-2.019c.09-.166.135-.25.156-.329a.6.6 0 0 0 .018-.217c-.006-.082-.043-.19-.115-.403A5.667 5.667 0 1 1 14 7.667",
    opacity: 0.7
  })));
};
export default SvgSocial;